import { FC, Fragment } from 'react';
import { styled } from '@mui/material/styles';
import RecordRow from 'components/RecordRow';
import { furtherCased, formatLabel } from 'helpers/kyc/text-formatting';

const StyledLink = styled('a')(({ theme }) => ({
  color: theme.palette.primary.main,
  textDecoration: 'none',
  cursor: 'pointer',
  fontWeight: 'normal',
}));

type Props = {
  data: Array<{
    name: string;
    value: string;
    snippet?: string;
  }>;
  type: string;
  index: number;
};

const SanitizedHitDataDisplay: FC<Props> = ({ data, type, index }) => {
  return (
    <Fragment>
      {data.map((item) => (
        <RecordRow
          key={`${type}-${index}-${item.name}`}
          label={formatLabel(item.name)}
        >
          {item.name.toLowerCase().includes('url') &&
          item.value.toLowerCase().startsWith('http') ? (
            <StyledLink
              href={item.value}
              target="_blank"
              rel="noopener noreferrer"
            >
              {item.value}
            </StyledLink>
          ) : (
            furtherCased(item.value)
          )}
        </RecordRow>
      ))}
    </Fragment>
  );
};

export default SanitizedHitDataDisplay;
